const cache = new Map();
const CONCURRENCY = 4;
const HTTP_RE = /^https?:\/\//i;

function getSizeFromPerformanceTiming(url) {
  const entries = performance.getEntriesByName(url);
  if (!entries.length) return null;
  const entry = entries[entries.length - 1];
  return entry.encodedBodySize > 0 ? entry.encodedBodySize : null;
}

async function getRemoteContentLength(url) {
  if (!url || !HTTP_RE.test(url)) return null;
  if (cache.has(url)) return cache.get(url);

  // 1. Performance Resource Timing: zero cost if the browser already loaded the asset
  //    and the server sends Timing-Allow-Origin.
  const existing = getSizeFromPerformanceTiming(url);
  if (existing !== null) {
    cache.set(url, existing);
    return existing;
  }

  // 2. fetch() uses the browser HTTP cache by default, so if the asset is already
  //    loaded on the canvas this reads from cache — no extra network request.
  //    blob.size is always accurate regardless of server headers.
  try {
    const resp = await fetch(url, { mode: 'cors' });
    if (!resp.ok) throw new Error(resp.status);
    const blob = await resp.blob();
    cache.set(url, blob.size);
    return blob.size;
  } catch {
    // Network error, CORS block, or non-2xx response.
  }

  cache.set(url, null);
  return null;
}

export async function getMediaSizes(urlSet) {
  const urls = [...urlSet].filter(Boolean);
  const results = new Map();
  for (let i = 0; i < urls.length; i += CONCURRENCY) {
    const chunk = urls.slice(i, i + CONCURRENCY);
    // eslint-disable-next-line no-await-in-loop
    const sizes = await Promise.all(chunk.map((url) => getRemoteContentLength(url)));
    chunk.forEach((url, idx) => results.set(url, sizes[idx]));
  }
  return results;
}

export function formatBytes(bytes) {
  if (!bytes || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1000)), units.length - 1);
  return `${(bytes / 1000 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function clearMediaSizeCache() {
  cache.clear();
}
